/**
 * 回到顶部图标
 */
const BackTopIcon = ({ width = 32, height = 32, color = '#000000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.99976 20.1144L5.88538 22L15.3135 12.5719L15.3135 10.6863L13.4278 10.6863L3.99976 20.1144Z"
        fill="black"
      />
      <path
        d="M27.7854 20.1144L25.8998 22L16.4717 12.5719L16.4717 10.6863L18.3573 10.6863L27.7854 20.1144Z"
        fill={color}
      />
    </svg>
  )
}

export default BackTopIcon
